import Info from '../common/item/Info.item'
import { Warning as WarningIcon } from '@mui/icons-material'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

const MissingUnitWeightInfo: React.FC<{ type: 'pemd' | 'report' }> = ({ type }) => {
  const { t } = useTranslation()

  return (
    <Info>
      <Box display="flex" sx={{ justifyContent: 'flex-start !important;' }} alignItems="center">
        <WarningIcon color="error" sx={{ marginRight: '5px' }} />
        <span>{t(`reports:components.missingUnit.${type}`)}</span>
      </Box>
    </Info>
  )
}

export default MissingUnitWeightInfo
